// extracted by mini-css-extract-plugin
export var productVideoBox = "productVideo-module--productVideoBox--hE7gN";
export var productVideoText = "productVideo-module--productVideoText--l0VDb";
export var productVideoDivider = "productVideo-module--productVideoDivider--58fOv";
export var centerTextAlign = "productVideo-module--centerTextAlign--cyAMP";
export var productVideoButton = "productVideo-module--productVideoButton--v7DCC";
export var productVideoClose = "productVideo-module--productVideoClose---4nZC";
export var productVideoIframe = "productVideo-module--productVideoIframe--R6Qav";
export var productVideoIframeBox = "productVideo-module--productVideoIframeBox--2Kw-F";